'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Brain, TrendingUp, Heart, Camera } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const insights = [
{
  icon: <Brain size={20} className="text-[#4caf7d]" />,
  quote: 'Muốn trải nghiệm thật',
  desc: 'Không hình thức — không phong trào — không chỉ để "điền vào CV"',
  tag: 'Authentic',
  color: '#4caf7d'
},
{
  icon: <TrendingUp size={20} className="text-[#e8a030]" />,
  quote: 'Muốn phát triển kỹ năng & CV',
  desc: 'Teamwork, lãnh đạo, trách nhiệm — những thứ nhà tuyển dụng tìm kiếm',
  tag: 'Grow',
  color: '#e8a030'
},
{
  icon: <Heart size={20} className="text-[#a8d87a]" />,
  quote: 'Muốn làm điều có ý nghĩa',
  desc: 'Thế hệ Z không chỉ muốn làm — họ muốn cảm thấy mình đang tạo ra sự thay đổi',
  tag: 'Impact',
  color: '#a8d87a'
},
{
  icon: <Camera size={20} className="text-[#f5c96a]" />,
  quote: 'Muốn có nội dung để chia sẻ',
  desc: 'Hình ảnh, video, câu chuyện — nội dung chân thực nhất đến từ trải nghiệm thật',
  tag: 'Share',
  color: '#f5c96a'
}];


export default function Slide04Insight({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0f2318]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1724455872716-df439709d7c2"
          alt="Nhóm sinh viên trẻ trung năng động cùng nhau ngoài trời, thể hiện tinh thần đoàn kết và khám phá"
          className="w-full h-full object-cover opacity-8" />

        <div className="absolute inset-0 bg-gradient-to-b from-[#0f2318] via-[#1a3a2a]/30 to-[#0f2318]" />
        <div className="absolute top-1/3 left-0 w-[400px] h-[400px] rounded-full bg-[rgba(76,175,125,0.05)] blur-3xl" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge">Insight sinh viên</div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            Hành trình trải nghiệm
          </h2>
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] tracking-tight">
            <span className="text-gradient-green">của sinh viên</span>
          </h2>
        </div>

        <div className="fade-in-up mb-12">
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 fade-in-up">
          {insights.map((item, i) =>
          <div
            key={`insight-${item.tag}`}
            className="glass-card p-7 relative overflow-hidden transition-all duration-300 hover:-translate-y-1 group"
            style={{ transitionDelay: `${i * 0.08}s` }}>

              <div
              className="absolute top-0 left-0 w-full h-0.5 opacity-60"
              style={{ background: `linear-gradient(90deg, ${item.color}, transparent)` }} />

              <div className="flex items-start gap-4">
                <div
                className="p-2.5 rounded-lg flex-shrink-0"
                style={{ background: `${item.color}20`, border: `1px solid ${item.color}30` }}>

                  {item.icon}
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-display font-700 text-[17px] lg:text-[19px] text-[#f0ede6]">
                      {item.quote}
                    </h3>
                    <span
                    className="text-[10px] font-700 uppercase tracking-widest px-2 py-0.5 rounded-full flex-shrink-0 ml-3"
                    style={{ background: `${item.color}20`, color: item.color }}>

                      {item.tag}
                    </span>
                  </div>
                  <p className="font-body text-[14px] text-[#a0b8a8] leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="fade-in-up mt-10 text-center">
          <p className="font-display text-[clamp(16px,2vw,20px)] font-600 text-[#f0ede6]">
            Tri An Green Volunteer Camp được thiết kế để{' '}
            <span className="text-gradient-amber">đáp ứng đúng 4 nhu cầu này</span>
          </p>
        </div>
      </div>
    </SlideWrapper>);

}